(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDashboardController', WarningDashboardController);

    WarningDashboardController.$inject = ['$state', 'TabObjectsDashboard', 'TabObjectsMap', 'pagingParams', 'ObjectMap', 'AlertService', 'WarningsDashboard', 'NgTableParams', 'ngTableEventsChannel', '$scope', '$interval'];

    function WarningDashboardController($state, TabObjectsDashboard, TabObjectsMap, pagingParams, ObjectMap, AlertService, WarningsDashboard, NgTableParams, ngTableEventsChannel, $scope, $interval) {
        var vm = this;
        vm.applyFilter = applyFilter;

        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleet.id = pagingParams.fleet;
        vm.selectedObjectType.id = pagingParams.objectType;
        vm.filterElastic = pagingParams.filterElastic;
        vm.selectedFleets = [];
        vm.selectedCondition = {};
        vm.objectCounting = {
            online: 0,
            offline: 0,
            warning: 0
        };

        vm.object = [];
        vm.mapStyle = {};

        vm.topNamePage = 1;
        vm.topObjectsPage = 1;

        var map = ObjectMap.build("warning-map");
        L.gridLayer.googleMutant({
            maxZoom: 24,
            type: 'terrain'
        }).addTo(map);

        vm.markers = [];
        vm.locations = [];
        vm.icons = [];
        vm.labels = [];
        vm.consoleL = [];
        var boundsArray = [];

        function loadAll() {
            var data = {
                filter: pagingParams.filter,
                fleet: vm.fleet.id,
                objectType: vm.objectType.id
            };
            TabObjectsMap.query(data, onSuccess, onError);
            TabObjectsDashboard.stat({
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            }, onSuccessDash, onError);

            // Load data
            pollTopName();
            pollTopObjects();

            // Reload data every 20 secs
            vm.namePoll = $interval(pollTopName, 20000);
            vm.objectPoll = $interval(pollTopObjects, 20000);
        }

        function pollTopName() {
            WarningsDashboard.topName(vm.filterElastic, innerOnSuccess, onError);
        }

        function pollTopObjects() {
            WarningsDashboard.topObjects(vm.filterElastic, objectOnSuccess, onError);
        }

        function innerOnSuccess(result) {
            vm.tableNameParams = new NgTableParams({page: vm.topNamePage, count: 10}, {counts: [], dataset: result});
        }

        function objectOnSuccess(result) {
            vm.tableTopParams = new NgTableParams({page: vm.topObjectsPage, count: 10}, {counts: [], dataset: result});
        }

        $scope.$watch('vm.tableNameParams', function (params) {
            // ngTableEventsChannel.onDatasetChanged(function() {
            //         vm.tableNameParams.page(vm.topNamePage);
            // }, $scope, vm.tableNameParams );
            ngTableEventsChannel.onPagesChanged(function () {
                vm.topNamePage = vm.tableNameParams.page();
            }, $scope, vm.tableNameParams);
        });

        $scope.$watch('vm.tableTopParams', function (params) {
            // ngTableEventsChannel.onDatasetChanged(function() {
            //         vm.tableTopParams.page(vm.topObjectsPage);
            // }, $scope, vm.tableTopParams );
            ngTableEventsChannel.onPagesChanged(function () {
                vm.topObjectsPage = vm.tableTopParams.page();
            }, $scope, vm.tableTopParams);
        });

        function getCoordinate(object){
            var lat = object.objectLatitude;
            var lng = object.objectLongitude;

            if((lat === null && lng === null) || (lat === "null" && lng === "null")){
                lat = object.fieldLatitude;
                lng = object.fieldLongitude;

                if((lat === "null" && lng === "null")){
                    lat = null;
                    lng = null;
                }
            }

            return (!lat || !lng) ? null : {lat:lat,lng:lng};
        }

        function onSuccess(result) {
            result.forEach(function (object) {
                var coord = getCoordinate(object);
                if (coord !== null && object.level > 0) {
                    var consoleLink = '#/dashboards/tab-objects-dashboard/' + object.fleet.id + '/' + object.id + '/' + object.objectType.id;

                    var lati = parseFloat(coord.lat), lngi = parseFloat(coord.lng);
                    if(angular.isNumber(lati) && angular.isNumber(lngi)){
                        vm.locations.push({lat: lati, lng: lngi});
                        vm.icons.push(ObjectMap.getMarkerIcon(object.objectTracked, object.level));
                        vm.labels.push({name: object.objectName, warning: object.warnings});
                        vm.consoleL.push(consoleLink);
                    }

                    // var marker = L.marker([coord.lat, coord.lng], {icon: ObjectMap.getMarkerIcon(object.objectTracked, object.level)})
                    //     .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + object.objectName + "</a><br\><span>Warning: " + object.warnings + "</span>");
                    // markersLayer.addLayer(marker);
                    // boundsArray.push([coord.lat, coord.lng]);
                }
            });
            initMap();
            if (boundsArray.length > 0)
                map.fitBounds(boundsArray, {maxZoom: 16});
            else
                map.fitBounds([[45.501467, 9.132729], [45.426099, 9.244652]]);
        }


        function onSuccessDash(count) {
            vm.objectCounting.online = count[0];
            vm.objectCounting.offline = count[1];
            vm.objectCounting.warning = count[2];
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $scope.$on('$destroy', function () {
            if (vm.namePoll)
                $interval.cancel(vm.namePoll);
            if (vm.objectPoll)
                $interval.cancel(vm.objectPoll);
        });

        function applyFilter(fleet, objectType) {
            // Fleet
            if(fleet && fleet.id > 0) {
                vm.fleet = fleet;
                vm.filterElastic.fleets = [fleet];          // only selected fleet
            } else {
                vm.fleet = vm.selectedFleets || [];
                vm.filterElastic.fleets = vm.fleet;         // all fleets
            }

            // Object Type
            if (objectType && objectType.id > 0) {
                vm.objectType = objectType;
                vm.filterElastic.objectType = objectType;   // only selected object type
            } else {
                vm.objectType = { id: -1 };
                delete vm.filterElastic.objectType;          // no object type
            }

            loadAll();
            transition(false);
        }


        function transition(notify) {

            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                objectType: vm.selectedObjectType.id,
                fleet: vm.selectedFleet.id,
                filterElastic: vm.filterElastic
            }, {notify: notify, location: "replace"});
        }

        function initMap() {
            var markers = L.markerClusterGroup();

            for (var i = 0; i < vm.locations.length; i++) {
                var coord = vm.locations[i];
                var title = vm.labels[i];
                var icon = vm.icons[i];
                var consoleLink = vm.consoleL[i];
                var marker = L.marker(L.latLng([coord.lat, coord.lng]), {icon: icon})
                    .bindPopup("<span>Object: </span><a href=" + consoleLink + ">" + title.name + "</a><br\><span>Warning: " + title.warning + "</span>");
                marker.addTo(markers);
                boundsArray.push([coord.lat, coord.lng]);
            }

            markers.addTo(map);
        }
    }
})();
